
export default function ArrowSimple() {
    return (
        <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.5 7.75829L0.75 2.00829L2.09167 0.666626L6.5 5.07496L10.9083 0.666626L12.25 2.00829L6.5 7.75829Z" fill="var(--global-gray)" />
        </svg>
    );
}